import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsProfilesAsyncSlice } from './get';

export const coreSonarObjectsProfilesReducers = combineReducers({
	get: getCoreSonarObjectsProfilesAsyncSlice.asyncReducers
});

export const coreSonarObjectsProfilesWatchers = combineAllWatchers([
	getCoreSonarObjectsProfilesAsyncSlice.asyncWatchers
]);
